import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { reducer as form } from 'redux-form';
import { participant } from './participant';
import { meta } from './meta';
import { node } from './node';
import { errors } from './errors';

const reducer = combineReducers({
  participant,
  meta,
  node,
  errors,
  form,
});

const middleware =
  process.env.NODE_ENV === 'development' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? compose(
        applyMiddleware(apiMiddleware),
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
          window.__REDUX_DEVTOOLS_EXTENSION__(),
      )
    : applyMiddleware(apiMiddleware);

export const configureStore = () => createStore(reducer, undefined, middleware);



// WEBPACK FOOTER //
// ./src/reducers/index.js